import React from "react";
import { Routes, Route, useParams } from 'react-router-dom';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Signup from './Pages/Signup';
import TermsAndCondition from './Pages/TermsAndCondition';
import Upload from './Pages/Upload';
import ViewRecord from './Pages/ViewRecord';
import AddRecord from './Pages/AddRecord';
import EditRecord from './Pages/EditRecord';
import AddContact from './Pages/AddContact';
import EditContact from './Pages/EditContact';
import ManageAccount from './Pages/ManageAccount';
import ForgotPassword from "./Pages/ForgotPassword";
import ProtectedRoute from './Pages/Components/ProtectedRoute';

const App = () => {

  return (
      <>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* M6 fix: Protected routes — require authentication */}
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/manage-contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
          <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
          <Route exact path="/view/:recordId" element={<ProtectedRoute><ViewRecord/></ProtectedRoute>}/>
          <Route path="/add-record" element={<ProtectedRoute><AddRecord /></ProtectedRoute>} />
          <Route path="/edit-record/:Id" element={<ProtectedRoute><EditRecord /></ProtectedRoute>} />
          <Route path="/add-contact" element={<ProtectedRoute><AddContact /></ProtectedRoute>} />
          <Route path="/edit-contact/:contactId" element={<ProtectedRoute><EditContact /></ProtectedRoute>} />
          <Route path="/manage-account" element={<ProtectedRoute><ManageAccount /></ProtectedRoute>} />
        </Routes>
      </>
  );
};

export default App;
